import { useEffect } from 'react';
import { useHits, useInstantSearch } from 'react-instantsearch';
export default function CallbacksHandler({ callbacks, instantSearchApi }) {
    const { hits } = useHits();
    const { results, setIndexUiState, setUiState, refresh, } = useInstantSearch();
    // eslint-disable-next-line no-underscore-dangle
    const isLoading = results.__isArtificial;
    useEffect(() => {
        // eslint-disable-next-line no-param-reassign
        instantSearchApi.setIndexUiState = setIndexUiState;
        // eslint-disable-next-line no-param-reassign
        instantSearchApi.setUiState = setUiState;
        // eslint-disable-next-line no-param-reassign
        instantSearchApi.refresh = refresh;
    }, [instantSearchApi, setIndexUiState, setUiState, refresh]);
    useEffect(() => {
        if (isLoading) {
            callbacks.beforeFirstRender.forEach((callback) => (callback()));
        }
        else {
            callbacks.afterFirstRender.forEach((callback) => (callback()));
        }
    }, [isLoading, callbacks]);
    useEffect(() => {
        callbacks.afterRender.forEach((callback) => (callback()));
    }, [hits, callbacks]);
    return null;
}
